import { render, staticRenderFns } from "./UpdateAppSetting.vue?vue&type=template&id=470d0701&"
import script from "./UpdateAppSetting.vue?vue&type=script&lang=js&"
export * from "./UpdateAppSetting.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAppSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470d0701')) {
      api.createRecord('470d0701', component.options)
    } else {
      api.reload('470d0701', component.options)
    }
    module.hot.accept("./UpdateAppSetting.vue?vue&type=template&id=470d0701&", function () {
      api.rerender('470d0701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/UpdateAppSetting.vue"
export default component.exports